import { ItineraryTypes } from './types';

/**
 * Sorts itinerary items by position within each date group.
 * Items with defined positions are sorted numerically.
 * Items without positions appear at the end in their original order.
 */
export const sortItineraryItemsByPosition = (
  items: ItineraryTypes['ItineraryItem'][]
): ItineraryTypes['ItineraryItem'][] => {
  return items.sort((a, b) => {
    // Items with positions come first, sorted by position
    // Items without positions come last, maintaining original order
    const posA = a.position ?? Infinity;
    const posB = b.position ?? Infinity;
    return posA - posB;
  });
};

/**
 * Groups itinerary items by date and sorts them by position within each group.
 */
export const groupAndSortItineraryItems = (
  items: ItineraryTypes['ItineraryItem'][]
): Record<string, ItineraryTypes['ItineraryItem'][]> => {
  const grouped = items.reduce((acc, item) => {
    const date = item.date || '';
    if (!acc[date]) {
      acc[date] = [];
    }
    acc[date].push(item);
    return acc;
  }, {} as Record<string, ItineraryTypes['ItineraryItem'][]>);

  // Sort items within each group
  Object.keys(grouped).forEach(date => {
    grouped[date] = sortItineraryItemsByPosition(grouped[date]);
  });

  return grouped;
};